import React from "react";

const Loading = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      width: "100%"
    }}
  >
    Loading...
  </div>
);

export default Loading;
